import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ApiService } from '../../app/servicios/api/api.service';
import { LoginI } from '../modelos/login.interface';
import { ResponseI } from '../modelos/response.interface';
import { Router } from '@angular/router';
import { RecuperarContrasenaI } from '../modelos/recuperarContra';
import { ToastrService } from 'ngx-toastr';
 
declare global {
  interface Window {
    turnstile?: any;
  }
}
 
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
 
  loginForm = new FormGroup({
    username: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required)
  });
 
  // (ya no necesitas siteKey aquí porque usamos auto-render en el HTML)
  // siteKey: string;
 
  Recuperar: RecuperarContrasenaI;
  RecuFormControl = new FormControl('', [
    Validators.required,
    Validators.minLength(8),
    Validators.maxLength(15),
    Validators.pattern('[a-zA-Z0-9 ]*')
  ]);
 
  // OJO: evita tildes en template refs; si puedes, renómbralas en el HTML a openModalRecuContrasena / closeModalRecuContrasena
  @ViewChild('openModalRecuContraseña') openModalRecuContraseña: ElementRef;
  @ViewChild('closeModalRecuContraseña') closeModalRecuContraseña: ElementRef;
 
  constructor(
    private api: ApiService,
    private router: Router,
    private toastr: ToastrService
  ) {
    // this.siteKey = '0x4AAAAAAB7DDyzI5tIjrPZO';
  }
 
  errorStatus: boolean = false;
  errorMsj: any = 'Usuario o contraseña inválidos...';
  btnIngresar: boolean = true;
 
  // Deja esto si aún lo usas en otra parte
  RtaCaptcha: any = null;
 
  ngOnInit(): void {
    this.errorStatus = false;
    this.Recuperar = new RecuperarContrasenaI();
    this.checkTokenLocalS();
  }
 
  // Si más adelante usas callbacks manuales:
  resolved(captchaResponse: string) {
    // Turnstile auto-render ya escribe el token en un input oculto,
    // pero dejamos esto por compatibilidad.
    this.RtaCaptcha = captchaResponse;
  }
 
  checkTokenLocalS() {
    if (localStorage.getItem('token') == '' || localStorage.getItem('token') == null) {
      this.router.navigate(['login']);
    } else if (localStorage.getItem('token') != '' || localStorage.getItem('token') != null) {
      if (localStorage.getItem('rol') == 'Administrador') {
        this.router.navigate(['admin']);
      }
      if (localStorage.getItem('rol') == 'Fuente') {
        this.router.navigate(['caratula']);
      }
    }
  }
 
  /** Lee el token generado por Turnstile.
   *  Con auto-render, Cloudflare inserta un input hidden: name="cf-turnstile-response"
   *  Mantenemos fallback a #cfToken por si aún lo tienes en el HTML.
   */
  private getTurnstileToken(): string {
    const autoInput = document.querySelector('input[name="cf-turnstile-response"]') as HTMLInputElement | null;
    if (autoInput?.value) return autoInput.value.trim();
 
    const legacy = document.getElementById('cfToken') as HTMLInputElement | null;
    if (legacy?.value) return legacy.value.trim();
 
    return '';
  }
 
  /** Resetea el widget tras error para forzar un nuevo challenge */
  private resetTurnstile(): void {
    try {
      window.turnstile?.reset?.(); // resetea todos los widgets auto-render
    } catch { /* noop */ }
  }
 
  onLogin(form: LoginI) {
    this.btnIngresar = false;
    this.errorStatus = false;
    this.errorMsj = '';
 
    // 1) Validar formulario
    if (this.loginForm.invalid) {
      this.btnIngresar = true;
      this.errorStatus = true;
      this.errorMsj = 'Complete usuario y contraseña.';
      return;
    }
 
    // 2) Obtener token de Turnstile (requerido)
    const token = this.getTurnstileToken();
    if (!token) {
      this.btnIngresar = true;
      this.errorStatus = true;
      this.errorMsj = 'Por favor completa el captcha.';
      return;
    }
 
    // 3) Enviar credenciales + token al backend
    //    Para no cambiar tu ApiService, mandamos el token dentro del payload.
    const payload: any = { ...form, turnstileToken: token };
 
    this.api.loginUser(form).subscribe({
      next: (data: ResponseI) => {
        // OJO: esta condición con "||" siempre da true si dataResponse.token != "".
        // Lo correcto usualmente es comprobar que el token venga y guardarlo.
        if (data?.token) {
          localStorage.setItem('token', data.token);
          localStorage.setItem('id', data.usuario.id);
          localStorage.setItem('usuario', data.usuario.usuario);
          localStorage.setItem('nombre', data.usuario.nombre);
          localStorage.setItem('correo', data.usuario.correo);
          localStorage.setItem('rol', data.usuario.rol);
          localStorage.setItem('tipo', data.usuario.tipo);
          localStorage.setItem('nuevaClave', data.usuario.nuevaClave);
          localStorage.setItem('ExpiracionToken', data.usuario.vigencia);
 
          if (data.usuario.tipo == 'DANE') {
            if (localStorage.getItem('nuevaClave') == 'true') {
              this.router.navigate(['cambiarclave']);
            } else {
              this.router.navigate(['admin']);
            }
          } else if (data.usuario.rol == 'Fuente') {
            localStorage.setItem('caratulaOk', '1');
            if (localStorage.getItem('nuevaClave') == 'true') {
              this.router.navigate(['cambiarclave']);
            } else {
              this.router.navigate(['caratula']);
            }
          } else if (data.usuario.rol == 'Supersolidaria') {
            if (localStorage.getItem('nuevaClave') == 'true') {
              this.router.navigate(['cambiarclave']);
            } else {
              this.router.navigate(['carguemasivosuper']);
            }
          }
        } else {
          // Respuesta sin token válido
          this.btnIngresar = true;
          this.errorStatus = true;
          this.errorMsj = 'Respuesta inválida del servidor.';
          this.resetTurnstile();
        }
      },
      error: (_) => {
        this.btnIngresar = true;
        this.errorStatus = true;
        this.errorMsj = 'Usuario o contraseña inválidos.';
        this.resetTurnstile();
      }
    });
  }
 
  recuperarContrasena() {
    this.openModalRecuContraseña?.nativeElement?.click();
  }
 
  enviarCorreo() {
    this.Recuperar.user = this.RecuFormControl.value;
    this.api.recuperarContrasena(this.Recuperar).subscribe({
      next: (result) => {
        if (result.status == 200) {
          this.toastr.success('Se enviará un correo con su nueva contraseña.', 'OK!');
          this.closeModalRecuContraseña?.nativeElement?.click();
          this.RecuFormControl.setValue('');
        } else {
          this.toastr.error(result.result, 'Error!');
          this.closeModalRecuContraseña?.nativeElement?.click();
          this.RecuFormControl.setValue('');
        }
      },
      error: () => {
        this.toastr.error('No se pudo recuperar la contraseña.', 'Error!');
      }
    });
  }
}